import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistorySubtaskSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#FFF7D6" />
        <rect width="16" height="16" transform="translate(8 8)" fill="#FFF7D6" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3636 11C10.6105 11 10 11.6105 10 12.3636C10 13.0663 10.5314 13.6448 11.2142 13.7192V14.9999V18.6364C11.2142 19.4649 11.8858 20.1364 12.7142 20.1364H13.5232C13.7226 20.6422 14.2156 21 14.7922 21H20.6364C21.3895 21 22 20.3895 22 19.6364C22 18.8833 21.3895 18.2728 20.6364 18.2728H14.7922C14.2156 18.2728 13.7226 18.6307 13.5232 19.1364H12.7142C12.4381 19.1364 12.2142 18.9126 12.2142 18.6364V16.4146C12.3706 16.4698 12.5389 16.4999 12.7142 16.4999H13.5232C13.7226 17.0057 14.2156 17.3635 14.7922 17.3635H20.6364C21.3895 17.3635 22 16.753 22 15.9999C22 15.2468 21.3895 14.6363 20.6364 14.6363H14.7922C14.2156 14.6363 13.7226 14.9942 13.5232 15.4999H12.7142C12.4381 15.4999 12.2142 15.2761 12.2142 14.9999V13.7273H20.6364C21.3895 13.7273 22 13.1168 22 12.3636C22 11.6105 21.3895 11 20.6364 11H11.3636Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default TaskHistorySubtaskSVG;
